import { enumLabel } from "../components/ui/enumLabel";
/** Payment-purpose values from the API EPaymentType enum. */
export const PAYMENT_TYPE_LABELS = {
  // Historical values remain readable without changing stored API data.
  transfer: "Transfer", booking: "Booking", topup: "Top-up",
  wallet_topup: "Wallet Top-up", checkout: "Checkout", shipment: "Shipment", order: "Order",
  shopforme: "Shop for Me", fx: "Currency Exchange", vtu: "Airtime & Data",
  shipment_adjustment: "Shipment Adjustment", carts: "Cart Checkout", amazon_shop: "Amazon Shop", naija_shop: "Naija Shop",
} as const;
export type PaymentType = keyof typeof PAYMENT_TYPE_LABELS;
export function paymentTypeLabel(value?: string): string {
  return PAYMENT_TYPE_LABELS[value?.toLowerCase() as PaymentType] || (value ? enumLabel(value) : "—");
}
export function transactionCategoryLabel(value?: string): string {
  return value === "wallet" ? "Wallet" : paymentTypeLabel(value);
}
